export default __webpack_public_path__ + "static/bg-ford-41b164f1b6d15b63d612f3431bb316ba.jpeg";